export default __webpack_public_path__ + "static/Screen Shot 2020-09-03 at 9.16.55 am-6ae69ee85b23d004b32bfce3470761f2.png";